module.exports = __webpack_public_path__ + "static/img/anxun71.aa625bd5.png";